module.exports = {"530524101":"田园镇","530524102":"漭水镇","530524103":"柯街镇","530524104":"卡斯镇","530524105":"勐统镇","530524106":"温泉镇","530524107":"大田坝镇","530524108":"鸡飞镇","530524109":"翁堵镇","530524205":"湾甸傣族乡","530524206":"更戛乡","530524207":"珠街彝族乡","530524208":"耈街彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530524.json
// module id = 2387
// module chunks = 0